import React from 'react';
import ProgressBar from './ProgressBar';
import './ScoreListItem.scss';
import assessmentImage from '../images';

const ScoreListItem = ({
  image,
  name = '',
  statusText = '',
  statusColor,
  value = 0,
  maxValue = 0,
  barColor = '#6ECA4B',
  valueColor,
  onClick = () => { },
  clickable = true,
  hasData = true,
}) => {
  return (
    <div
      className={`score-list-item${clickable ? '' : ' not-clickable'}`}
      onClick={clickable ? onClick : undefined}
    >
      <img className="list-image" src={image} alt="" />
      <div className="list-item">
        <div className="item-name">{name}</div>
        {statusText ? <div className="status-text" style={statusColor ? { color: statusColor } : undefined}>{statusText}</div> : null}
      </div>
      <div className="item-value">
        <div className="score-container">
          <div className="value" style={valueColor ? { color: valueColor } : undefined}>{value}</div>
          <div className="max-value">/{maxValue}</div>
        </div>
        <ProgressBar value={value} maxValue={maxValue} barColor={barColor} width="100%" height="6px" showBar={hasData} />
      </div>
      {clickable && <img className="nav-right-image" src={assessmentImage.chevronRight} alt="" />}
    </div>
  );
};

export default ScoreListItem;
